import { BorrowerSeperator } from './config'

export const borrowerMenuKey = (borrowerSeparator: BorrowerSeperator, menuKey: string) => {
  const index = Object.values(BorrowerSeperator).indexOf(borrowerSeparator as any)
  return `${menuKey}${index == 0 ? '' : index + 1}`
}

export const borrowerSepFromMenuKey = (menuKey: string) => {
  const lastDigit = Number(menuKey.substring(menuKey.length - 1))
  if (Number.isNaN(lastDigit)) return BorrowerSeperator.BORROWER

  return Object.values(BorrowerSeperator)[lastDigit - 1]
}

export const getBorrowerOriginalMenuKey = (menuKey: string) => {
  const match = menuKey.match(/^[a-zA-Z]+/)
  if (match) return match[0]
  return menuKey
}
